var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"separator-breadcrumb border-top"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card mb-4"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"card-title mb-3"},[_vm._v("Manage expenses")]),_vm._v(" "),_c('fieldset',{staticClass:"border p-3"},[_c('div'),_vm._v(" "),_c('div',[_vm._m(0),_vm._v(" "),_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.systemExpenses,"fixed-header":true,"pagination-options":{
                  enabled: true,
                  mode: 'records',
                  perPage: 6,
                  position: 'bottom',
                  perPageDropdown: [3, 7, 9],
                  dropdownAllowAll: false,
                  setCurrentPage: 1,
                  nextLabel: 'next',
                  prevLabel: 'prev',
                  rowsPerPageLabel: 'Rows per page',
                  ofLabel: 'of',
                  pageLabel: 'page', // for 'pages' mode
                  allLabel: 'All',
                }}})],1)])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"expensesLoader"},[_c('span',{staticClass:"spinner-border spinner-border-sm",attrs:{"role":"status","aria-hidden":"true"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-spinner fa-spin",staticStyle:{"font-size":"24px","color":"blue"}}),_vm._v("loading sales...\n              ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bd95949","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/expenses/manageexpenses.vue
// module id = null
// module chunks = 